import { render, staticRenderFns } from "./promoBlock.vue?vue&type=template&id=99500bc6&scoped=true&"
import script from "./promoBlock.vue?vue&type=script&lang=js&"
export * from "./promoBlock.vue?vue&type=script&lang=js&"
import style0 from "./promoBlock.vue?vue&type=style&index=0&id=99500bc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99500bc6",
  null
  
)

export default component.exports